export const SET_SCREEN = 'settings/SET_SCREEN';
export const SET_LOCALE = 'settings/SET_LOCALE';
export const SET_COLOR_MODE = 'settings/SET_COLOR_MODE';
